import axios from '@/utils/axios'

export const getTaskList = (payload) => {
    return axios.get('/task', {
        params: payload
    })
}

export const getTaskByID = (id) => {
    return axios.get(`/task/${id}`)
}

export const updateTask = (id, data) => {
    return axios.put(`/task/${id}`, data)
}

export const createTask = (data) => {
    return axios.post(`/task`, data)
}

export const deleteTask = (id) => {
    return axios.delete(`/task/${id}`)
}

// task record
export const createTaskRecord = (taskId, data) => {
    return axios.post(`/task_record/${taskId}`, data)
}

export const updateTaskRecord = (taskRecordId, data) => {
    return axios.put(`/task_record/${taskRecordId}`, data)
}

export const deleteTaskRecord = (taskId, data) => {
    return axios.delete(`/task_record/${taskId}`, {
        params: data
    })
}

export const setUserReceiveTask = (data) => {
    return axios.post(`/set_receive_task`, data)
}

export const getUserReceiveTask = (payload) => {
    return axios.get('/get_receive_task', {
        params: payload
    })
}

export const notifyUserReceiveTaskWW = (data) => {
    return axios.post(`/notify_receive_task`, data)
}